module.exports = "/_next/static/images/ThePayoff-sm-f0dc9f158e2015217b267168340cc8ff.webp";